import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock } from "vue";
var _hoisted_1 = { class: "post-manage-container" };
var _hoisted_2 = { class: "post-manage-top-nav" };
var _hoisted_3 = {
    key: 0,
    class: "post-manage-content"
};
var _hoisted_4 = {
    key: 1,
    class: "post-search-content"
};
var _hoisted_5 = {
    key: 0,
    class: "search-loading"
};
var _hoisted_6 = {
    key: 1,
    class: "search-result"
};
var _hoisted_7 = { id: "post-aria" };
var _hoisted_8 = {
    key: 2,
    class: "search-null-view"
};
import { ref } from "vue";
import PostBoardRowShow from "@/components/BlogComponents/PostBoardRowShow.vue";
import CustomSVG from "@/components/custom/CustomSVG.vue";
import NullView from "@/views/tipViews/Null.vue";
import PostBox from "@/components/BlogComponents/PostBoxRow.vue";
import api from "@/utils/api";
export default /*@__PURE__*/ _defineComponent({
    __name: 'postReleaseManager',
    setup: function (__props) {
        var searchText = ref("");
        var searchInputTimeout = undefined;
        var searchItems = ref([]);
        var isLoadingSeach = ref(false);
        var handleInputSeachText = function (event) {
            console.log("handleInputSeachText", event);
            if (searchText.value.length === 0) {
                clearTimeout(searchInputTimeout);
                searchItems.value = [];
                isLoadingSeach.value = false;
            }
            else {
                clearTimeout(searchInputTimeout);
                isLoadingSeach.value = false;
                searchInputTimeout = setTimeout(function () {
                    isLoadingSeach.value = true;
                    searchItems.value = [];
                    api.requestWithSmallLoad
                        .get("/search", {
                        params: {
                            q: searchText.value,
                        },
                    })
                        .then(function (res) {
                        searchItems.value = res.data;
                    })
                        .catch(function (err) {
                        window.$notifyError("搜索失败", err.response.msg);
                    })
                        .finally(function () {
                        isLoadingSeach.value = false;
                    });
                }, 2000);
            }
        };
        var variants = {
            invisible: {
                opacity: 0,
                y: 20,
            },
            visible: function (custom) { return ({
                opacity: 1,
                y: 0,
                transition: { delay: custom * 0.3, ease: "easeInOut", duration: 0.4 },
            }); },
        };
        return function (_ctx, _cache) {
            var _component_n_icon = _resolveComponent("n-icon");
            var _component_n_input = _resolveComponent("n-input");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("nav", _hoisted_2, [
                    _createVNode(_component_n_input, {
                        class: "post-manage-top-nav-search",
                        value: searchText.value,
                        "onUpdate:value": [
                            _cache[0] || (_cache[0] = function ($event) { return ((searchText).value = $event); }),
                            handleInputSeachText
                        ],
                        round: "",
                        placeholder: "搜索"
                    }, {
                        prefix: _withCtx(function () { return [
                            _createVNode(_component_n_icon, { size: "1.6rem" }, {
                                default: _withCtx(function () { return [
                                    _createVNode(CustomSVG, { icon: "ManageSearchFilled" })
                                ]; }),
                                _: 1
                            })
                        ]; }),
                        _: 1
                    }, 8, ["value"])
                ]),
                (_unref(searchItems) && _unref(searchItems).length === 0 && !isLoadingSeach.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                        _createVNode(PostBoardRowShow, {
                            target: "/postlist",
                            mark: "home",
                            markvalue: "/"
                        })
                    ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_4, [
                        (isLoadingSeach.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                                _createVNode(_component_n_icon, {
                                    size: "5rem",
                                    class: "search-loading"
                                }, {
                                    default: _withCtx(function () { return [
                                        _createVNode(CustomSVG, {
                                            icon: "SmallLoading2",
                                            class: "search-loading-icon"
                                        })
                                    ]; }),
                                    _: 1
                                })
                            ]))
                            : (_unref(searchItems) && _unref(searchItems).length !== 0)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                                    _createElementVNode("div", _hoisted_7, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(searchItems), function (post, index) {
                                            return (_openBlock(), _createElementBlock("div", {
                                                key: "release-post-".concat(post.id),
                                                style: { "width": "100%", "display": "flex", "justify-content": "center", "align-items": "center" },
                                                comment: "使用 Motion 组件在切页的时候有 bug，所以先替换等效 div"
                                            }, [
                                                (_openBlock(), _createBlock(PostBox, {
                                                    key: index,
                                                    propPost: post
                                                }, null, 8, ["propPost"]))
                                            ]));
                                        }), 128))
                                    ])
                                ]))
                                : (_openBlock(), _createElementBlock("div", _hoisted_8, [
                                    _createVNode(NullView)
                                ]))
                    ]))
            ]));
        };
    }
});
